/* MIMOSA infinite scroll for collection pages (added 2026-07-11)
 * Auto-loads the next page of products when the shopper nears the bottom.
 * - Hides numbered pagination when JS is available (falls back to it without JS)
 * - Survives AJAX filter/sort re-renders (facet-filters.js replaces #filter-results)
 * - Dedupes products, stops cleanly on the last page
 */
(function () {
  'use strict';

  var LOOKAHEAD = '900px';   // start loading this far before the bottom
  var loading = false;
  var observer = null;
  var sentinel = null;

  function q(root, sel) { return root.querySelector(sel); }

  function findGrid(root) {
    var res = q(root, '#filter-results');
    return res ? res.querySelector('ul.grid') : null;
  }

  function findNextUrl(root) {
    var res = q(root, '#filter-results') || root;
    var a = res.querySelector('a[rel="next"]');
    if (!a) {
      var links = res.querySelectorAll('a[href*="page="]');
      for (var i = 0; i < links.length; i++) {
        var label = (links[i].getAttribute('aria-label') || '') + ' ' + (links[i].textContent || '');
        if (/next|\u203a|\u2192|\u00bb/i.test(label)) { a = links[i]; break; }
      }
    }
    return a ? a.getAttribute('href') : null;
  }

  function hidePagination(root) {
    var res = q(root, '#filter-results');
    if (!res) return;
    var pags = res.querySelectorAll('.pagination, nav.pagination, [class*="pagination"]');
    for (var i = 0; i < pags.length; i++) pags[i].style.display = 'none';
  }

  function productKeys(grid) {
    var keys = {};
    var anchors = grid.querySelectorAll('li a[href*="/products/"]');
    for (var i = 0; i < anchors.length; i++) {
      keys[anchors[i].getAttribute('href').split('?')[0]] = true;
    }
    return keys;
  }

  function loadNext(grid, nextUrl) {
    if (loading || !nextUrl) return;
    loading = true;
    if (sentinel) sentinel.textContent = 'Loading more sarees\u2026';

    fetch(nextUrl)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newGrid = findGrid(doc);
        var currentGrid = findGrid(document);
        if (!newGrid || !currentGrid) { teardown(); return; }

        var existing = productKeys(currentGrid);
        var items = newGrid.children;
        var appended = 0;
        for (var i = 0; i < items.length; i++) {
          var li = items[i];
          var a = li.querySelector('a[href*="/products/"]');
          var key = a ? a.getAttribute('href').split('?')[0] : null;
          if (key && existing[key]) continue;           // skip duplicates
          if (!a && li.className.indexOf('promo-item') !== -1) continue; // skip repeated promos
          currentGrid.appendChild(li.cloneNode(true));
          appended++;
        }

        var next = findNextUrl(doc);
        loading = false;
        if (sentinel) sentinel.textContent = '';
        if (!next || appended === 0) {
          teardown();
        } else {
          sentinel.setAttribute('data-next-url', next);
        }
      })
      .catch(function () { loading = false; teardown(); });
  }

  function teardown() {
    if (observer) { observer.disconnect(); observer = null; }
    if (sentinel) { sentinel.textContent = ''; }
  }

  function setup() {
    teardown();
    var grid = findGrid(document);
    if (!grid) return;
    var next = findNextUrl(document);
    if (!next) return;                 // single page \u2014 nothing to do

    hidePagination(document);

    sentinel = document.createElement('div');
    sentinel.className = 'cc-infinite-sentinel';
    sentinel.setAttribute('data-next-url', next);
    sentinel.style.cssText = 'text-align:center;padding:20px;min-height:1px;grid-column:1/-1;';
    grid.parentNode.insertBefore(sentinel, grid.nextSibling);

    observer = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) {
          loadNext(findGrid(document), sentinel.getAttribute('data-next-url'));
        }
      }
    }, { rootMargin: LOOKAHEAD });
    observer.observe(sentinel);
  }

  // Re-initialise when the filters/sort AJAX replaces the results.
  function watchRerenders() {
    var res = document.getElementById('filter-results');
    if (!res || !res.parentNode) return;
    var pending = null;
    new MutationObserver(function () {
      if (sentinel && document.body.contains(sentinel)) return; // our own appends
      clearTimeout(pending);
      pending = setTimeout(setup, 150);
    }).observe(res.parentNode, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setup(); watchRerenders(); });
  } else {
    setup();
    watchRerenders();
  }
})();
